import { OptionDto } from "@/dtos";
import { IncidenceOrigin } from "@/helpers/types";

const origins = [
    { value: IncidenceOrigin.MANUAL, label: 'Manual' },
    { value: IncidenceOrigin.WHATSAPP, label: 'WhatsApp' },
    { value: IncidenceOrigin.MAINTENANCE, label: 'Mantenimiento' },
] as OptionDto[];


export const getOriginOption = (value?: number): OptionDto => {
    return origins.find((x) => x.value == value) ?? origins[0];
}